/**
 * Merge master options with selected options.
 *
 * @param masterOptions - The base list of options from the API/master data
 * @param selectedOptions - The currently selected options (may include custom-created ones)
 * @returns Merged array containing all master options plus any custom-selected options
 */
export const mergeOptionsWithSelected = <
  T extends { value: any; label: string }
>(
  masterOptions: T[],
  selectedOptions: Array<{ value: any; label: string; [key: string]: any }>
): T[] => {
  if (!selectedOptions || selectedOptions.length === 0) {
    return masterOptions;
  }

  const masterValues = new Set(masterOptions.map((opt) => opt.value));
  const missingOptions = selectedOptions.filter(
    (selected) => !masterValues.has(selected.value)
  ) as T[];

  return [...masterOptions, ...missingOptions];
};
